module.exports = __webpack_public_path__ + "img/1514804588.88512c72.jpg";